import React, { useState, useRef, MouseEvent } from 'react';
import { useOutsideClick } from '@hooks/useOutsideClick';
import './SubMenuMobile.scss';
import { SubNavigation } from '@layouts/Header/Header.types';

interface SubMenuMobileProps {
  submenuLinks: SubNavigation['content'];
  title: string;
}

export const SubMenuMobile = ({ submenuLinks, title }: SubMenuMobileProps) => {
  const [active, setActive] = useState(false);

  const subMenuRef = useRef(null);
  const handleClickOutside = () => {
    setActive(false);
  };
  useOutsideClick(subMenuRef, handleClickOutside);

  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setActive(!active);
  };

  let currentLink = submenuLinks.filter(
    (item) => parseInt(item.PageId) === parseInt(window.pageId)
  )[0];
  let list = [];
  if (!currentLink && submenuLinks.length) {
    currentLink = submenuLinks[0];
    list = submenuLinks.filter((item) => parseInt(item.PageId) !== parseInt(currentLink.PageId));
  } else {
    list = submenuLinks.filter((item) => parseInt(item.PageId) !== parseInt(window.pageId));
  }

  const subMenuLinks = list.map((item, index) => {
    return (
      <li key={index} className='c-submenu-mobile-link-container'>
        <a href={item.Href} className='c-submenu-mobile-link'>
          {item.Text}
        </a>
      </li>
    );
  });

  return (
    <div className='c-submenu-mobile'>
      <div className='c-submenu-mobile-current-link'>
        {currentLink && (
          <a onClick={onClick} href={currentLink.Href} className='c-submenu-mobile-link no-border'>
            {currentLink.Text}
          </a>
        )}
        {!currentLink && (
          <a onClick={onClick} href='#' className='c-submenu-mobile-link no-border'>
            {title}
          </a>
        )}
        {active ? (
          <i className='icon-chevron-up' onClick={onClick} />
        ) : (
          <i className='icon-chevron-down' onClick={onClick} />
        )}
      </div>
      {active && <ul className='c-submenu-mobile-list'>{subMenuLinks}</ul>}
    </div>
  );
};
